<template>
	<div class="indexContainer">
		<Header></Header>
		<div class="bannerWrapper">
			<img src="../../assets/img/customer/banner1.jpg" alt="" class="bannerImg" style="width: 100%;"/>
		</div>
		<div class="indexContentContainer">
			<div class="part-box container">
				<div class="part-titile wow slideInUp">
					<h3 class="title">客户案例</h3>
				</div>
				<div class="part-content">
					<div class="item-box wow slideInLeft">
						<img src="../../assets/img/customer/pic1.jpg" alt="" />
						<h4 class="stitle">中新汽使用SO56运输管理系统</h4>
						<!--<p class="text">
							主要针对自有车辆进行监控，外部车辆如能提供终端对接，可将车辆自有终端与平台进行数据对接后，实现对车辆的监控。
						</p>-->
					</div>
					<div class="item-box wow slideInLeft">
						<img src="../../assets/img/customer/pic2.jpg" alt="" />
						<h4 class="stitle">蓝色亿蔚使用SO56运输管理系统</h4>
						<!--<p class="text">
							主要用在临时车辆或未在国家货运平台上监管的车辆，即提供自带电池的便携式终端，由司机携带或与货物绑定，通过回单时进行回收，实现对整个运输过程的监控。
						</p>-->
					</div>
					<div class="item-box wow slideInRight">
						<img src="../../assets/img/customer/pic3.jpg" alt="" />
						<h4 class="stitle">中国物流长沙分公司使用SO56仓储管理系统</h4>
						<!--<p class="text">
							采用移动定位技术，使用手机端定位的方式完成对车辆及司机位置信息变动的监控。
						</p>-->
					</div>
				</div>
				<div class="part-content" data-wow-delay="0.8s">
					<div class="item-box wow slideInLeft">
						<img src="../../assets/img/customer/pic4.jpg" alt="" />
						<h4 class="stitle">中新汽使用SO56运输管理系统</h4>
						<!--<p class="text">
							主要针对自有车辆进行监控，外部车辆如能提供终端对接，可将车辆自有终端与平台进行数据对接后，实现对车辆的监控。
						</p>-->
					</div>
					<div class="item-box wow slideInLeft">
						<img src="../../assets/img/customer/pic5.jpg" alt="" />
						<h4 class="stitle">蓝色亿蔚使用SO56运输管理系统</h4>
						<!--<p class="text">
							主要用在临时车辆或未在国家货运平台上监管的车辆，即提供自带电池的便携式终端，由司机携带或与货物绑定，通过回单时进行回收，实现对整个运输过程的监控。
						</p>-->
					</div>
					<div class="item-box wow slideInRight">
						<img src="../../assets/img/customer/pic6.jpg" alt="" />
						<h4 class="stitle">中国物流长沙分公司使用SO56仓储管理系统</h4>
						<!--<p class="text">
							采用移动定位技术，使用手机端定位的方式完成对车辆及司机位置信息变动的监控。
						</p>-->
					</div>
				</div>
			</div>
			<div class="part-box container wow slideInUp">
				<div class="part-titile">
					<h3 class="title">合作企业</h3>
				</div>
				<div class="part-content">
					<img src="../../assets/img/customer/pic7.jpg" style="width: 100%;"/>
				</div>
			</div>
		</div>
    <!-- <Suggest></Suggest> -->
		<Footer></Footer>
	</div>
</template>

<script>
	import Header from '../../components/common/header.vue'
	import Footer from '../../components/common/footer.vue'
	import { WOW } from '../../assets/js/wow.min.js'
  // import Suggest from '../../components/common/suggest.vue'
	export default {
		components: {
			Header,
			Footer,
      // Suggest
		},
		created: function(){
			new WOW({live: false}).init();
		},
		mounted: function() {
			new WOW({live: false}).init();
		}
	}
</script>

<style scoped>
	@import '../../assets/css/animate.min.css';
	@import '../../assets/css/bootstrap.min.css'
	.bannerWrapper .bannerImg {
		width: 100%;
	}
	.indexContentContainer {
		margin: 60px auto;
		overflow: hidden;
		position: relative;
		z-index: 10;
	}
	
	.carousel-inner>.item {
		height: 195px;
	}
	
	.indexContentContainer .part-box {
		margin-top: 40px;
		text-align: center;
	}
	
	.part-box .title {
		font-size: 20px;
		font-weight: bold;
		color: #FF6600;
		position: relative;
		display: inline-block;
	}
	
	.part-box .title::after {
		display: block;
		content: '';
		clear: both;
		width: 30px;
		height: 3px;
		margin: 15px auto;
		background: #FF6600;
	}
	
	.part-box .part-content {
		display: flex;
		margin-bottom: 20px;
	}
	
	.part-box .part-content .item-box {
		flex: 1;
		margin-right: 20px;
		border: 1px solid #F0F0F0;
		padding: 0;
		position: relative;
	}
	.part-box .part-content .item-box img{
		width: 100%;
	}
	.part-box .part-content .item-box:last-child {
		margin-right: 0;
	}
	
	.part-content .item-box .stitle {
		padding: 20px 0;
	    position: absolute;
	    bottom: 0;
	    width: 100%;
	    color: #fff;
	    font-size: 16px;
	    margin-bottom: 0;
	    background: rgba(0, 0, 0, 0.6);
	}
	
	.part-content .item-box .text {
		color: #979EA7;
		font-size: 12px;
		line-height: 25px;
		text-align: justify;
	}
</style>


// WEBPACK FOOTER //
// src/components/pages/customer_case.vue